import React, { useState } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import fetchBatchDetails from "./useBatchDetails";
import useBatchDetails from "./useBatchDetails";
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  FormControl,
  Grid,
  MenuItem,
  Select,
  Typography,
} from "@material-ui/core";
import useFilter from "./useFilter";
import axios from "axios";
import { appUrl } from "../../../../../../utils/config";
import { fetchInventoryReconciliationFilters } from "../../../../containers/actions/common/inventoryStatusActions";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: "1em",
    // width: "100%",
    backgroundColor: "#E8F3F8",
    padding: theme.spacing(2),
    borderRadius: "4px",
    display: "flex",

    overflowX: "auto",
    flexWrap: "nowrap",
  },
  formControl: {
    minWidth: "100%",
    maxWidth: 140,
  },
  header: {
    fontSize: "14px",
    fontWeight: "bold",
    color: "#000",
    marginBottom: "1em",
  },
  divider: {
    backgroundColor: "#B0BEC5",
    height: "100%",
    width: "2px",
    margin: theme.spacing(0, 2),
  },
  rightAlign: {
    textAlign: "right",
  },
  btnFilter: {
    textTransform: "none",
    borderRadius: "50px",
    backgroundColor: "#ec6535",
    color: "white",
    "&:hover": {
      backgroundColor: "#ec6535",
    },
  },
  btnClear: {
    textTransform: "none",
    color: "#2196f3",
    textDecoration: "underline",
  },
  backdrop: {
    zIndex: 15000,
    color: "#fff",
  },
}));

export default function Ribbon({
  filter,
  // clearFilters,
  handleChange,
  saveFilters,
  vendorData,
  //  setFilterDialog,
  // initialFilterState,
  setFilter,
}) {
  const { apiData } = useBatchDetails(filter, vendorData);
  const classes = useStyles();
  const [filterLoading, setFilterLoading] = useState(false);
  const [filterDialog, setFilterDialog] = useState(false);

  // const initialFilterState = {
  //   timeStamp: "All",
  //   onHandQuantityDifference: "All",
  //   quantityCommittedDifference: "All",
  //   reasonForDifference: "All",
  // };

  // const clearFilters = () => {

  //   const initialFilterState = {
  //     timeStamp: "All",
  //     onHandQuantityDifference: "All",
  //     quantityCommittedDifference: "All",
  //     reasonForDifference: "All",
  //   };
  //   setFilter(initialFilterState);
  //   setFilterLoading(true);
  //   // const uri = `${appUrl}/user/saveReconciliationInventoryFilters`;
  //   axios
  //     .post(`${appUrl}/user/saveReconciliationInventoryFilters`, initialFilterState)
  //     .then((res) => {
  //       // throw new Error("Something went wrong");
  //       if (res.data.status) {
  //         setFilterDialog("success");
  //       } else {
  //         setFilterDialog("error");
  //       }
  //     })
  //     .catch((err) => {
  //       // setFilterError(err.message || "Something went wrong");
  //       setFilterDialog("error");
  //     })
  //     .finally(() => {
  //       setFilterLoading(false);
  //     });
  // };

  const clearFilters = async () => {
  const initialFilterState = {
    inventoryReconciliationDashboard: {
      timeStamp: "All",
      onHandQuantityDifference: "All",
      quantityCommittedDifference: "All",
      reasonForDifference: "All",
    },
  };

  setFilter(initialFilterState);
  setFilterLoading(true);

  try {
    // First save the filters
    const res = await axios.post(`${appUrl}/user/saveFilters`, initialFilterState);

    if (res.data.status) {
      setFilterDialog("success");

      // ✅ Only call fetchInventoryReconciliationFilters if save is successful
      const result = await fetchInventoryReconciliationFilters()();

      if (result.status && result.save_filter_options) {
        setFilter(result.save_filter_options);
      } else {
        console.warn("No reconciliation filter options found in the response.");
      }
    } else {
      setFilterDialog("error");
    }
  } catch (err) {
    console.error("Error saving filters:", err);
    setFilterDialog("error");
  } finally {
    setFilterLoading(false);
  }
};

  return (
    <Box className={classes.root}>
      <Grid container alignItems="stetch" spacing={3}>
        <Grid item>
          <Typography className={classes.header}>CMO</Typography>
          <Typography variant="body2">
            {localStorage.collabType === "CMO"
              ? localStorage.organizationName
              : vendorData?.vendorMosymphonyID?.label || ""}
          </Typography>
        </Grid>

        <Grid item>
          <Typography className={classes.header}>Plant ID</Typography>
          <Typography variant="body2">
            {vendorData?.vendorPlant?.plantCode || ""}
          </Typography>
        </Grid>
        <Grid item>
          <Typography className={classes.header}>
            Storage Location ID
          </Typography>
          <Typography variant="body2">
            {/* {apiData?.reconciliationDetailsList?.flatMap((item) =>
              item?.lotNumberDetailsList?.[0].map(
                (lot) => lot.storageLocationID || "NA"
              )
            ) || []} */}

            {apiData?.reconciliationDetailsList?.[0]?.lotNumberDetailsList?.[0]?.storageLocationID || ""}
          </Typography>
        </Grid>
        <Grid item>
          <Typography className={classes.header}>Timestamp</Typography>
          <FormControl
            className={classes.formControl}
            style={{ width: "100%" }}
          >
            <Select
              variant="outlined"
              size="small"
              name="timeStamp"
              value={filter.timeStamp}
              onChange={handleChange}
              style={{
                width: "100%",
                height: "30px",
                backgroundColor: "white",
              }}
            >
              <MenuItem value="All">All</MenuItem>
              <MenuItem value="Past hour">Past Hour</MenuItem>
              <MenuItem value="Past 24 hours">Past 24 Hours</MenuItem>
              <MenuItem value="Past week">Past Week</MenuItem>
              <MenuItem value="Past month">Past Month</MenuItem>
              <MenuItem value="Past three months">Past Three Months</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item>
          <Typography className={classes.header}>
            On-Hand Qty. Difference (%):
          </Typography>

          <FormControl
            className={classes.formControl}
            style={{ width: "100%" }}
          >
            <Select
              variant="outlined"
              size="small"
              name="onHandQuantityDifference"
              value={filter.onHandQuantityDifference}
              onChange={handleChange}
              style={{
                width: "100%",
                height: "30px",
                backgroundColor: "white",
              }}
            >
              <MenuItem value="All">All</MenuItem>
              <MenuItem value="Less than 0.1">Less Than 0.1</MenuItem>
              <MenuItem value="Less than 1">Less Than 1</MenuItem>
              <MenuItem value="Less than 10">Less Than 10</MenuItem>
              <MenuItem value="More than 10">More Than 10</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item>
          <Typography className={classes.header}>
            Qty. Committed Difference (%)
          </Typography>
          <FormControl
            className={classes.formControl}
            style={{ width: "100%" }}
          >
            <Select
              variant="outlined"
              size="small"
              name="quantityCommittedDifference"
              value={filter.quantityCommittedDifference}
              onChange={handleChange}
              style={{
                width: "100%",
                height: "30px",
                backgroundColor: "white",
              }}
            >
              <MenuItem value="All">All</MenuItem>
              <MenuItem value="Less than 0.1">Less Than 0.1</MenuItem>
              <MenuItem value="Less than 1">Less Than 1</MenuItem>
              <MenuItem value="Less than 10">Less Than 10</MenuItem>
              <MenuItem value="More than 10">More Than 10</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item>
          <Typography className={classes.header}>
            Reason For Difference
          </Typography>
          <FormControl
            className={classes.formControl}
            style={{ width: "100%" }}
          >
            <Select
              variant="outlined"
              size="small"
              name="reasonForDifference"
              value={filter.reasonForDifference}
              onChange={handleChange}
              style={{
                width: "100%",
                height: "30px",
                backgroundColor: "white",
              }}
            >
              <MenuItem value="All">All</MenuItem>
              <MenuItem value="Decimal rounding">Decimal Rounding</MenuItem>
              <MenuItem value="Wastage, explained and accounted">
                Wastage, Explained And Accounted
              </MenuItem>
              <MenuItem value="Material used but not yet updated in SAP">
                Material Used But Not Yet Updated In SAP
              </MenuItem>
              <MenuItem value="Need more information">
                Need More Information
              </MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item alignContent="flex-end">
          <Button
            className={classes.btnFilter}
            variant="contained"
            size="small"
            onClick={saveFilters}
          >
            Save Filters
          </Button>
        </Grid>

        <Grid item alignContent="flex-end">
          <Button
            className={classes.btnClear}
            size="small"
            onClick={clearFilters}
          >
            Clear All Filters
          </Button>
        </Grid>
      </Grid>
      <Backdrop
        className={classes.backdrop}
        open={filterLoading}
      // onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
}
